import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFiltering, setSorting } from "../../features/filter/filterSlice";

const Sidebar = () => {
    const { sorting, filtering } = useSelector((state) => state.filter);
    const dispatch = useDispatch();
    const handleSort = (e) => {
        dispatch(setSorting(e.target.value));
    };
    const handleFilter = (e) => {
        dispatch(setFiltering(e.target.value));
    };
    return (
        <aside>
            <div className="sidebar-items">
                <div className="sidebar-content">
                    <h4>Sort</h4>
                    <select
                        name="sort"
                        id="lws-sort"
                        className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
                        onChange={handleSort}
                        value={sorting}
                    >
                        <option value="default">Default</option>
                        <option value="newest">Newest</option>
                        <option value="most_liked">Most Liked</option>
                    </select>
                </div>
                <div className="sidebar-content">
                    <h4>Filter</h4>
                    <div className="radio-group">
                        {/* handle filter on button click */}
                        <div>
                            <input
                                type="radio"
                                name="filter"
                                id="lws-all"
                                // defaultChecked
                                className="radio"
                                value="all"
                                onChange={handleFilter}
                                defaultChecked={
                                    filtering === "all" ? true : false
                                }
                            />
                            <label htmlFor="lws-all">All</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                value="saved"
                                name="filter"
                                id="lws-saved"
                                className="radio"
                                onChange={handleFilter}
                                defaultChecked={
                                    filtering === "saved" ? true : false
                                }
                            />
                            <label htmlFor="lws-saved">Saved</label>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
